const modalActivarCuenta = {
  'Modal Activar Cuenta Subtitulo': 'Activá tu cuenta a través del email que te enviamos',
  'Modal Activar Cuenta Texto': '¿No lo recibiste?',
  'Modal Activar Cuenta Boton Enviado': 'Ya te reenviamos el email de activación',
}

export default modalActivarCuenta
